var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcPlayerVolumeOn = function SvgIcPlayerVolumeOn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_player_volume_on")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_player_volume_on",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9048187,1.14998498 C16.9674994,1.28318152 17,1.42857403 17,1.57578201 L17,23.424218 C17,23.9765027 16.5522847,24.424218 16,24.424218 C15.852792,24.424218 15.7073995,24.3917174 15.574203,24.3290367 L0.574202964,17.2702132 C0.223710533,17.1052755 0,16.7527565 0,16.3653945 L0,8.63460554 C0,8.24724349 0.223710533,7.89472445 0.574202964,7.72978684 L15.574203,0.670963311 C16.0739205,0.435802102 16.6696575,0.650267406 16.9048187,1.14998498 Z M14.25,4.333 L2.75,9.745 L2.75,15.254 L14.25,20.666 L14.25,4.333 Z",
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8709406,2.32782365 C21.5486859,1.98527901 22.3757943,2.25701282 22.7183389,2.9347581 C24.1377975,5.7432427 24.8435316,8.95540935 24.8435316,12.55499 C24.8435316,16.1545707 24.1377975,19.3667374 22.7183389,22.175222 C22.3757943,22.8529673 21.5486859,23.1247011 20.8709406,22.7821564 C20.1931953,22.4396118 19.9214615,21.6125034 20.2640061,20.9347581 C21.4810263,18.5268101 22.0935316,15.7389768 22.0935316,12.55499 C22.0935316,9.37100328 21.4810263,6.58316994 20.2640061,4.17522197 C19.9214615,3.49747669 20.1931953,2.67036829 20.8709406,2.32782365 Z",
    id: "Path-3"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcPlayerVolumeOn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_player_volume_on.c0f43cae.svg";
export { ForwardRef as ReactComponent };